export default __webpack_public_path__ + "static/9-0f048c0bdbdcddc1c2ef2d454ed77724.jpg";